var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',{attrs:{"cols":_vm.smSize,"md":_vm.mdSize,"lg":_vm.lgSize}},[(_vm.visible)?[_vm._t("default",null,{"widget":_vm.widget,"settings":_vm.widget.settings})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }